import { NaturalPowerSource } from './NaturalPowerSource'
import { TraditionalPowerSource } from './TraditionalPowerSource'

export function PowerSources() {
  return (
    <div className="relative flex items-end w-full h-60">
      <NaturalPowerSource />
      <TraditionalPowerSource />
    </div>
  )
}
